import type { RulesResult } from '../../../assessment/types';
import s from '../styles/dashboard.module.css';

interface Props {
  rules: RulesResult;
}

const StrengthsConsiderations = ({ rules }: Props) => (
  <div className={s.ledger}>
    <div>
      <div className={s.ledgerLabel}>Strengths · what's working</div>
      {rules.strengths.length === 0 ? (
        <div className={s.ledgerItem}>
          <span className={`${s.ledgerDot} ${s.ledgerDotMuted}`} />
          <span className={s.ledgerText}>No standout strengths surfaced.</span>
        </div>
      ) : (
        rules.strengths.map((item, i) => (
          <div key={i} className={s.ledgerItem}>
            <span className={`${s.ledgerDot} ${s.ledgerDotPos}`} />
            <span className={s.ledgerText}>{item.text}</span>
          </div>
        ))
      )}
    </div>

    <div>
      <div className={s.ledgerLabel}>Considerations · to address</div>
      {rules.considerations.length === 0 ? (
        <div className={s.ledgerItem}>
          <span className={`${s.ledgerDot} ${s.ledgerDotMuted}`} />
          <span className={s.ledgerText}>No considerations surfaced.</span>
        </div>
      ) : (
        rules.considerations.map((item, i) => (
          <div key={i} className={s.ledgerItem}>
            <span className={`${s.ledgerDot} ${s.ledgerDotNeg}`} />
            <span className={s.ledgerText}>{item.text}</span>
          </div>
        ))
      )}
    </div>
  </div>
);

export default StrengthsConsiderations;
